import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import fmtFecha from "../../../../utils/fmtFecha";

function ListadoTraspasosSalida() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_ARTICULOS_TS = import.meta.env.VITE_URL_ARTICULOS_TS;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_TRASPASOS_SALIDA = import.meta.env.VITE_URL_TRASPASOS_SALIDA;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [traspasos, setTraspasos] = useState([]);

  const [areas, setAreas] = useState([]);
  const [areaDestinoEdit, setAreaDestinoEdit] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedAreaSalida, setSelectedAreaSalida] = useState("");
  const [selectedAreaDestino, setSelectedAreaDestino] = useState("");

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [numero_traspaso, setNumeroTraspaso] = useState("");
  const [filtroRecibida, setFiltroRecibida] = useState("");

  const [idEdit, setIdEdit] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(
        `${URL_TRASPASOS_SALIDA}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allTraspasos = response.data;
        // Array para pagination
        let arrayTabla = allTraspasos
          .sort((a, b) => (a.idTraspasosSalida < b.idTraspasosSalida ? 1 : -1))
          .map((a) => {
            if (user.areas == AREAS_GENERAL) {
              return {
                _id: a._id,
                numero: a.idTraspasosSalida,
                activo: a.is_active,
                fecha: a.fecha,
                observaciones: a.observaciones,
                total: a.total,
                areaSalida: a.areaSalida[0].name,
                areaDestino: a.areaDestino[0].name,
                idAreaSalida: a.areaSalida[0]._id,
                idAreaDestino: a.areaDestino[0]._id,
                recibida: a.recibida,
              };
            } else if (
              user.areas == a.areaSalida[0]._id ||
              user.areas == a.areaDestino[0]._id
            ) {
              return {
                _id: a._id,
                numero: a.idTraspasosSalida,
                activo: a.is_active,
                fecha: a.fecha,
                observaciones: a.observaciones,
                total: a.total,
                areaSalida: a.areaSalida[0].name,
                areaDestino: a.areaDestino[0].name,
                idAreaSalida: a.areaSalida[0]._id,
                idAreaDestino: a.areaDestino[0]._id,
                recibida: a.recibida,
              };
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setTraspasos(allTraspasos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, user]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedAreaSalida == 0 || selectedAreaSalida == a.idAreaSalida) &&
        (selectedAreaDestino == 0 || selectedAreaDestino == a.idAreaDestino) &&
        (activo == 0 || activo == a.is_active) &&
        (filtroRecibida == "" || filtroRecibida == a.recibida)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.areaSalida,
          a.areaDestino,
          new Intl.NumberFormat("en-US").format(a.total),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Traspasos Salida`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen Salida",
          "Almacen Destino",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Traspasos-Salida.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedAreaSalida == 0 || selectedAreaSalida == a.idAreaSalida) &&
        (selectedAreaDestino == 0 || selectedAreaDestino == a.idAreaDestino) &&
        (activo == 0 || activo == a.is_active) &&
        (filtroRecibida == "" || filtroRecibida == a.recibida)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Observaciones: a.observaciones,
          AreaSalida: a.areaSalida,
          AreaDestino: a.areaDestino,
          Cantidad: a.total,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoTraspasosSalida";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoTraspasosSalida",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Observaciones",
          "AreaSalida",
          "AreaDestino",
          "Cantidad",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Observaciones",
          "AreaSalida",
          "AreaDestino",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedAreaSalida == 0 || selectedAreaSalida == a.idAreaSalida) &&
        (selectedAreaDestino == 0 || selectedAreaDestino == a.idAreaDestino) &&
        (activo == 0 || activo == a.is_active) &&
        (filtroRecibida == "" || filtroRecibida == a.recibida)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.areaSalida,
          a.areaDestino,
          new Intl.NumberFormat("en-US").format(a.total),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Traspasos Salida`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen Salida",
          "Almacen Destino",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Salidas de Traspasos",
          email: mailTo,
          fileName: "ListadoTraspasosSalida.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Salidas de Traspasos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    areaDestino,
    observaciones,
    numero_traspaso,
    idEdit
  ) {
    setFecha(fecha);
    setObservaciones(observaciones);
    setNumeroTraspaso(numero_traspaso);
    setIdEdit(idEdit);
    setAreaDestinoEdit(areaDestino);
    toggleEdit();
  }

  // Ticket PDF function for thermal receipt style
  async function PDFOCTicket(
    numero,
    fecha,
    observaciones,
    areaSalida,
    areaDestino,
    total,
    idPDFOC
  ) {
    try {
      const response = await axios.get(`${URL_ARTICULOS_TS}/traspasoSalida/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      let allArticulos = response.data;
      let arrayTabla = allArticulos
        .map((a) => {
          return {
            id: a._id,
            idArticulo: a.articulos[0]._id,
            articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
            colorNombre: a.colores && a.colores.length > 0 ? a.colores[0].name : "",
            tallaNombre: a.tallas && a.tallas.length > 0 ? a.tallas[0].name : "",
            cantidad: a.cantidad,
            piezasPorCaja: a.articulos[0].piezasPorCaja,
            cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            precio: a.articulos[0].venta,
            total: parseFloat(a.articulos[0].venta) * parseFloat(a.cantidad),
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      let agrupado = dataFinal.reduce(function (groups, item) {
        const val = item["idArticulo"];
        groups[val] = groups[val] || {
          idArticulo: item.idArticulo,
          cantidad: 0,
          cajas: 0,
          total: 0
        };
        groups[val].cantidad += item.cantidad;
        groups[val].cajas += item.cajas;
        groups[val].articulos = item.articulos;
        groups[val].colorNombre = item.colorNombre;
        groups[val].tallaNombre = item.tallaNombre;
        groups[val].precio = item.precio;
        groups[val].total += item.total;
        groups[val].piezasPorCaja = item.piezasPorCaja;
        return groups;
      }, []);

      let agrupadoValues = Object.values(agrupado);

      let cant = dataFinal.map((c) => parseFloat(c.cantidad));
      let TC = cant.reduce((t, total, index) => t + total, 0);

      let cantCajas = dataFinal.map((c) => parseFloat(c.cajas));
      let totalCajas = cantCajas.reduce((t, total, index) => t + total, 0);

      let TT = dataFinal.map((c) => parseFloat(c.total));
      let TTT = TT.reduce((t, total, index) => t + total, 0);

      // Process data for table - truncate long names and format properly
      const data = agrupadoValues.map((a) => {
        // Truncate item name if too long (max 24 chars for 8cm width)
        const itemName = a.articulos.length > 24
          ? a.articulos.substring(0, 21) + "..."
          : a.articulos;

        return [
          itemName,
          a.colorNombre || "",
          a.tallaNombre || "",
          a.cantidad.toString(),
          `$${a.precio.toFixed(2)}`,
          `$${a.total.toFixed(2)}`,
        ];
      });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      // Calculate dynamic height based on content
      const baseHeight = 18; // Base height in cm
      const itemHeight = 0.5; // Height per item in cm
      const headerHeight = 8; // Height for header section
      const footerHeight = 8; // Height for footer
      const bufferHeight = 4; // Extra space at the end for cutting

      const totalHeight =
        headerHeight +
        dataPDFLimpia.length * itemHeight +
        footerHeight +
        bufferHeight;

      // Create PDF with proper thermal dimensions (8cm width) and calculated height
      const doc = new jsPDF("p", "cm", [8, totalHeight], true);

      // Generate QR code
      var base64 = await qrcode.toDataURL(idPDFOC);
      var img3 = new Image();
      img3.src = base64;

      var img2 = new Image();
      img2.src = "logoInstitucion.png";

      // HEADER SECTION with yPos tracking
      const centerX = 4; // Center of 8cm width
      const leftMargin = 0.2;
      const rightMargin = 7.8;
      let yPos = 0.3; // Start position

      // Logo
      doc.addImage(img2, "png", 6.5, yPos, 1.2, 0.8);
      yPos += 1.0; // Space after logo

      // Business information - centered with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space after business name

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("CALLE ##, COLONIA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text("CIUDAD, ESTADO CP", centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between address lines

      doc.text(`RFC:`, centerX, yPos, { align: "center" });
      yPos += 0.35; // More space after RFC

      doc.text("General de Ley de Personas Morales", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5; // More space before separator

      // Separator line
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Store information with better spacing
      doc.setFontSize(8);
      doc.text(`Almacen Salida: ${areaSalida}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      doc.text(`Almacen Destino: ${areaDestino}`, centerX, yPos, {
        align: "center",
      });
      yPos += 0.35; // More space between store info lines

      // Another separator
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.5; // More space after separator

      // Transaction information with better spacing
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`Fecha: ${fecha}`, centerX, yPos, { align: "center" });
      yPos += 0.4; // More space after date

      doc.setFont("helvetica", "normal");
      doc.text(`Traspaso Salida: ${numero}`, centerX, yPos, { align: "center" });
      yPos += 0.5; // More space before items

      doc.text(`Piezas: ${new Intl.NumberFormat("en-US").format(TC)}`, leftMargin, yPos);
      yPos += 0.6; // Much more space before final separator

      // Final separator before items
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.6; // Much more space before table starts

      // ITEMS TABLE with proper column widths for 8cm (6 columns)
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Can", "Precio", "Total"]],
        body: dataPDFLimpia,
        startY: yPos, // Use yPos instead of fixed value

        // Fixed column widths that total to ~7.6cm (leaving margins) - 6 columns
        columnStyles: {
          0: {
            cellWidth: 2, // Item name (largest)
            halign: "left",
            overflow: "linebreak",
            fontSize: 7,
          },
          1: {
            cellWidth: 1, // Color
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          2: {
            cellWidth: 1, // Talla
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          3: {
            cellWidth: 0.8, // Cantidad
            halign: "center",
            overflow: "hidden",
            fontSize: 7,
          },
          4: {
            cellWidth: 1.3, // Precio
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
          5: {
            cellWidth: 1.5, // Total
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
        },

        styles: {
          fontSize: 8,
          font: "helvetica",
          cellPadding: { top: 0.2, right: 0.1, bottom: 0.2, left: 0.1 }, // More vertical padding
          lineWidth: 0.01,
          lineColor: [180, 180, 180],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },

        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          halign: "center",
          cellPadding: { top: 0.25, right: 0.1, bottom: 0.25, left: 0.1 }, // More padding in header
        },

        margin: { left: leftMargin, right: leftMargin },
        tableWidth: "wrap",
        theme: "grid",
      });

      // Get the Y position after the table with much more space
      yPos = doc.lastAutoTable.finalY + 0.8; // Much more space after table

      // TOTALS SECTION
      doc.setLineWidth(0.02);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4; // More space after line

      // Total with emphasis
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);

      const totalLabelX = 3.5;
      doc.text("TOTAL:", totalLabelX, yPos);
      doc.text(`$${TTT.toFixed(2)}`, rightMargin - 0.1, yPos, {
        align: "right",
      });
      yPos += 0.8; // More space after total

      // FOOTER with more spacing
      yPos += 0.3;
      doc.setLineWidth(0.01);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 0.4;

      // Store policies - centered
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("POLÍTICAS DE LA TIENDA", centerX, yPos, {
        align: "center",
      });
      yPos += 0.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);

      const policies = [
        "**** NO ES UN COMPROBANTE FISCAL ****",
        "NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES",
        "NI POR DEFECTO",
        "**** GRACIAS POR SU PREFERENCIA ****",
      ];

      policies.forEach((line) => {
        doc.text(line, centerX, yPos, { align: "center" });
        yPos += 0.25;
      });

      yPos += 0.4;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text("¡Gracias por su confianza!", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.text("Conserve este comprobante", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // WhatsApp customer service info
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.text("WhatsApp Atención a clientes:", centerX, yPos, {
        align: "center",
      });
      yPos += 0.25;
      doc.setFont("helvetica", "normal");
      doc.text("495 103 6208 & 495 101 1713", centerX, yPos, {
        align: "center",
      });
      yPos += 0.4;

      // QR code - properly centered
      const qrSize = 1.6;
      doc.addImage(img3, "png", centerX - qrSize / 2, yPos, qrSize, qrSize);

      // Save and print
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");

    } catch (error) {
      console.error("Error in PDFOCTicket function:", error);
      Swal.fire({
        icon: "error",
        title: "Error generando PDF",
        text: "Hubo un problema al generar el PDF",
        footer: error.message,
      });
    }
  }

  async function PDFOC(
    numero,
    fecha,
    observaciones,
    areaSalida,
    areaDestino,
    total,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_TS}/traspasoSalida/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        console.log(allArticulos);
        let arrayTabla = allArticulos
          .map((a) => {
            return {
              id: a._id,
              idArticulo: a.articulos[0]._id,
              articulos:a.articulos[0].codigo + " - " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              piezasPorCaja: a.articulos[0].piezasPorCaja,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              precio: a.articulos[0].venta,
              total: parseFloat(a.articulos[0].venta) * parseFloat(a.cantidad),
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
            total: 0
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].total += item.total;
          groups[val].piezasPorCaja = item.piezasPorCaja;
          groups[val].precio = item.precio;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);


        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);

        let cantCajas = dataFinal.map((c) => parseFloat(c.cajas));
        let totalCajas = cantCajas.reduce((t, total, index) => t + total, 0);

        let TT = dataFinal.map((c) => parseFloat(c.total));
        let TTT = TT.reduce((t, total, index) => t + total, 0);

        const data = agrupadoValues.map((a) => {
          return [
            a.articulos,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precio),
            new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
            new Intl.NumberFormat("en-US").format(a.piezasPorCaja),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape","mm", "a4", true);
        var img = new Image();
        img.src = "Logo-Sistemify-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        doc.addImage(img2, "png", 140, 15, 38, 18);
        doc.text(`Traspaso Salida # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Almacen Salida ${areaSalida}`, 20, 30);
        doc.text(`Almacen Destino ${areaDestino}`, 20, 35);
        doc.text(`Piezas ${new Intl.NumberFormat("en-US").format(TC)}`, 20, 40);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Precio",
              "Cajas",
              "Piezas por Caja",
              "Cantidad",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              "",
              "Totales",
              new Intl.NumberFormat("en-US").format(totalCajas.toFixed(2)),
              "",
              new Intl.NumberFormat("en-US").format(TC),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(TTT),
            ],
          ],
          showFoot: "lastPage",
        });
        doc.save(`Traspaso-Salida-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }



  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Almacen Salida", field: "areaSalida", sortable: true },
    { name: "Almacen Destino", field: "areaDestino", sortable: true },
    { name: "Cantidad", field: "total", sortable: true },
    { name: "Recibida", field: "recibida", sortable: true },
    { name: "PDF", field: "PDF", sortable: false },
    // { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          // comment.activo.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.areaSalida.toLowerCase().includes(search.toLowerCase()) ||
          comment.areaDestino.toLowerCase().includes(search.toLowerCase()) ||
          comment.recibida.toLowerCase().includes(search.toLowerCase()) ||
          comment.total.toString().includes(search)
      );
    }
    if (selectedAreaSalida) {
      computedComments = computedComments.filter((e) =>
        e.idAreaSalida.includes(selectedAreaSalida)
      );
    }
    if (selectedAreaDestino) {
      computedComments = computedComments.filter((e) =>
        e.idAreaDestino.includes(selectedAreaDestino)
      );
    }
    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (filtroRecibida) {
      computedComments = computedComments.filter((e) =>
        e.recibida.includes(filtroRecibida)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
    selectedFechaInicio,
    selectedFechaFin,
    selectedAreaSalida,
    selectedAreaDestino,
    filtroRecibida,
  ]);



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_traspasos_salida ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.traspasos_salida_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/TraspasosSalidaCreate"
                >
                  Nueva Salida
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Salida
                </Button>
              )}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Salidas de Traspasos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Salidas de Traspasos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAreaSalida}
                  onChange={(e) => {
                    setSelectedAreaSalida(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAreaDestino}
                  onChange={(e) => {
                    setSelectedAreaDestino(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={filtroRecibida}
                  onChange={(e) => {
                    setFiltroRecibida(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{fmtFecha(a.fecha)}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.areaSalida}</td>
                      <td>{a.areaDestino}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total)}</td>
                      <td>{a.recibida}</td>
                      <td>
                        {user.traspasos_salida_create ? (
                          <div>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.numero,
                                  a.fecha,
                                  a.observaciones,
                                  a.areaSalida,
                                  a.areaDestino,
                                  a.total,
                                  a._id
                                )
                              }
                            >
                              <i className="far fa-file-pdf"></i>
                            </Button>
                            {" "}
                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                PDFOCTicket(
                                  a.numero,
                                  a.fecha,
                                  a.observaciones,
                                  a.areaSalida,
                                  a.areaDestino,
                                  a.total,
                                  a._id
                                )
                              }
                            >
                              <i className="fas fa-receipt"></i>
                            </Button>
                          </div>
                        ) : undefined}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />



      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoTraspasosSalida;
